import { useState } from 'react';
import { validateBoardDef, type BoardDef } from '@archon3d/core';
import { accountRequest } from '../net/accounts';

/** Keep earlier board-only cloud saves reachable when upgrading to complete game documents. */
export function LegacyBoardLibrary({ onImport }: { onImport: (board: BoardDef) => void }) {
  const [items, setItems] = useState<
    { name: string; revision: string; updatedAt: number; data: unknown }[]
  >([]);
  const [notice, setNotice] = useState(''),
    [busy, setBusy] = useState(false);
  return (
    <details className="editor-section">
      <summary>Import older cloud board saves</summary>
      <p className="hint">
        Sign in to retrieve boards saved before the complete game editor. Importing creates a new
        game with original character abilities and Default Arena; the old save is retained.
      </p>
      <button
        disabled={busy}
        onClick={() => {
          setBusy(true);
          void accountRequest<{ items: typeof items }>('library?kind=board')
            .then((result) => {
              setItems(result.items);
              setNotice(
                result.items.length
                  ? 'Choose a revision to import.'
                  : 'No older board saves found.',
              );
            })
            .catch((e) => setNotice((e as Error).message))
            .finally(() => setBusy(false));
        }}
      >
        Find older cloud boards
      </button>
      {notice && <p role="status">{notice}</p>}
      <ul className="saved-boards">
        {items.map((item) => (
          <li key={item.revision}>
            <span>
              {item.name} · {new Date(item.updatedAt).toLocaleString()}
            </span>
            <button
              onClick={() => {
                try {
                  onImport(validateBoardDef(item.data));
                } catch (e) {
                  setNotice((e as Error).message);
                }
              }}
            >
              Import board revision
            </button>
          </li>
        ))}
      </ul>
    </details>
  );
}
